import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const ArrowOutIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
      strokeWidth={strokeWidth}
    >
      <path
        d="M11.95 22H4.15002V2H11.95C12.5 2 12.95 1.55 12.95 1C12.95 0.45 12.5 0 11.95 0H4.15002C3.05002 0 2.15002 0.9 2.15002 2V22C2.15002 23.1 3.05002 24 4.15002 24H11.95C12.5 24 12.95 23.55 12.95 23C12.95 22.45 12.5 22 11.95 22Z"
        fill={color}
      />
      <path
        d="M22.71 11.29L16.71 5.29C16.32 4.9 15.69 4.9 15.3 5.29C14.91 5.68 14.91 6.31 15.3 6.7L19.59 10.99H9C8.45 10.99 8 11.44 8 11.99C8 12.54 8.45 12.99 9 12.99H19.59L15.3 17.28C14.91 17.67 14.91 18.3 15.3 18.69C15.69 19.08 16.32 19.08 16.71 18.69L22.71 12.69C23.1 12.3 23.1 11.67 22.71 11.28V11.29Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

ArrowOutIcon.displayName = 'ArrowOutIcon';
